module.exports = __webpack_public_path__ + "img/kr-product-ecmy-card2-bg.976882b.png";